import { CLOSE } from "@/src/lib/SmartDB/Commons/Constants/images";
import styles from './ModalWelcomeMessage.module.scss';
import { useModalWelcomeMessage } from './useModalWelcomeMessage';
import { WEBSITE_TITLE } from '@/src/utils/constants';

export const ModalWelcomeMessage = () => {
    //--------------------------------------
    const { isRefreshing, appStore, isOpen, handleOpen, handleClose } = useModalWelcomeMessage();
    //--------------------------------------
    return (
        <>
            {isOpen === true ? (
                <div className={styles.modal}>
                    <div className={`${styles.main}`}>
                        <div className={styles.popUp}>
                            <>
                                <header className={styles.headerModal}>
                                    <h2 className={styles.titleModal}>Welcome to {WEBSITE_TITLE}</h2>
                                    <svg width="45" height="45" className={styles.icon} onClick={handleClose}>
                                        <use href={CLOSE}></use>
                                    </svg>
                                </header>
                                <div className={styles.divBorder}>
                                    <div
                                        className={styles.textWithScroll}
                                        dangerouslySetInnerHTML={{
                                            __html: appStore.siteSettings?.welcomeMessage ?? '',
                                        }}
                                    ></div>
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
    //--------------------------------------
};
